import { Routes } from "@angular/router";
import { PerfilUserComponent } from "./perfil-user.component";
import { AccountComponent } from "./pages/account/account.component";
import { PaymentsComponent } from "./pages/payments/payments.component";
import { EstablishmentFavoritesComponent } from "./pages/establishment-favorites/establishment-favorites.component";
import { DevolucionesComponent } from "./pages/devoluciones/devoluciones.component";

export const PERFIL_USER_ROUTES: Routes = [

  {
    path: '',
    component: PerfilUserComponent,
    children: [
      {
        path: '',
        component: AccountComponent,
        pathMatch: 'full'
      },
      {
        path: 'payments',
        component: PaymentsComponent
      },
      {
        path: 'favorites-establishment',
        component: EstablishmentFavoritesComponent
      },
      {
        path: 'devoluciones',
        component: DevolucionesComponent
      },
      {
        path: 'recargos',
        loadChildren: () => import('./pages/recargos/recargos.routes').then(m => m.default)
      }
    ]
  }

]
